// Copyright (c) StrangeBee 2024

import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import RouteBuilder from '@Services/RouteBuilder';
import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';
import { OperationType } from 'thehive-sdk';

export const AttachmentContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const { action, details, rootId, context } = base;
    const { case: dataCase = {} } = data || {};

    const customDetails = {
        contentType: details.contentType,
        size: details.size,
    };

    const parent = context || dataCase;

    const path = RouteBuilder.compute('cases.attachments', { caseId: rootId });

    const libTitle: Record<OperationType, string> = {
        create: local('stream.card.attachment.create'),
        update: local('stream.card.attachment.update'),
        merge: '',
        delete: local('stream.card.attachment.delete'),
    };

    const title = action === 'create' ? details.name : libTitle[action];

    return (
        <StreamCard icon={<ICONS.CreateIcon />} title={title} base={base} path={path} parent={parent}>
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={rootId + key} prop={key} value={value} type="attachment" />
            ))}
        </StreamCard>
    );
};
